<template>
  <div class="daifuDetails">
    <div>
      <!-- 倒计时30分钟内且未付款进去 -->
      <UnPaidStatus v-if="time > 0 && noPay" :time="time" :total-price="totalPrice" :info="info" />
      <!-- 付款成功且付款方和发起方 -->
      <PaySucStatus v-if="(isPayFang || isFaQiFang) && paySuccess" :info="info" />
      <!-- 订单已删除 或者 订单30分钟之内没有支付 -->
      <DeleteStatus v-if="(time <= 0 && noPay) || isDelete" :info="info" />
      <!-- 订单已经被抢先支付成功了  订单成功并且不是支付方不是发起方 已退款的订单-->
      <OrderSucStatus v-if="(paySuccess && !isPayFang && !isFaQiFang) || isRefund" :info="info" />
    </div>
    <div class="daifuDetails-header_center">
      <div class="daifuDetails_dingdan">代付订单信息</div>
      <div class="daifuDetails_flexbox">
        <img v-lazy="lazyImage(workbooks.workbookPicurl) || {}" class="dingdan-img" />
        <div
          style="margin-left:9px;display: flex;flex-direction: column;justify-content: space-between;"
        >
          <div class="daifuDetails_dingdan-title">
            {{ workbooks.name || workbooks.workbookName }}
          </div>
          <div class="daifuDetails_flexbox_money">
            <span style="font-size:13px">￥</span>
            <span>{{ transPrice(workbooks.price) || transPrice(workbooks.workbookPrice) }}</span>
          </div>
        </div>
      </div>
      <div class="daifuDetails_dingdan_border"></div>
      <div class="daifuDetails_dingdan-text">备注</div>
      <div v-if="info.payAnotherRecord" class="remark">{{ info.payAnotherRecord.description }}</div>
    </div>
    <!-- 支付成功 -->
    <div v-if="paySuccess && isPayFang" class="give-friend" @click="giveFriend()">通知好友</div>
    <div class="daifuDetails_footer">
      <div class="shuoming">代付说明</div>
      <p class="daifuDetails_footer_text1">
        1.付款前请先与好友确认无误，避免受骗。
      </p>
      <p class="daifuDetails_footer_text2">
        2.付订单需要您在剩余时间内完成付款，否则订单会自动取消。
      </p>
      <p class="daifuDetails_footer_text2">3.如发生退款，实付金额将原路退还代付人。</p>
    </div>
    <van-overlay :show="show" class="daiFu-overlay" @click="show = false">
      <img src="https://img.yzcdn.cn/upload_files/2020/10/19/Flx2xsxVs5Z64SGNAxLo9BKrCRPH.png" />
    </van-overlay>
  </div>
</template>
<script>
import { Field, CountDown } from 'vant'
import { getformData, transPrice, timestamp } from '@/static/js/zjs.js'
import UnPaidStatus from './component/unpaidStatus'
import OrderSucStatus from './component/orderSucStatus'
import PaySucStatus from './component/paySucStatus'
import DeleteStatus from './component/deleteStatus'
export default {
  name: 'DaifuDetails',
  components: {
    PaySucStatus,
    UnPaidStatus,
    DeleteStatus,
    OrderSucStatus,
    [Field.name]: Field,
    [CountDown.name]: CountDown
  },
  data() {
    return {
      time: '',
      show: false,
      details: {
        payOrderGoods: [{}]
      },
      workbooks: {},
      totalPrice: '',
      OrderSucStatus: '',
      payOrderId: '',
      info: {},
      payOpenid: '', // 支付人的openid
      faqiOpneid: '' // 发起人的openid
    }
  },
  computed: {
    // 当前用户的openid
    openid() {
      return this.$store.state.user.openid
    },
    // 进入者是支付方
    isPayFang() {
      return this.openid === this.payOpenid
    },
    // 进入者是创建方
    isFaQiFang() {
      return this.openid === this.faqiOpneid
    },
    // 支付成功订单
    paySuccess() {
      return this.details.payStatus === 0 && this.details.ntResultCode === 'SUCCESS'
    },
    // 未支付订单
    noPay() {
      return this.details.payStatus === 0 && !this.details.ntResultCode
    },
    // 退款 有退款订单
    isRefund() {
      return this.details.payStatus === 3 || this.details.payStatus === 6
    },
    // 已删除订单
    isDelete() {
      return this.details.payStatus === 7 || this.details.payStatus === 8
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    transPrice,
    timestamp,
    // 支付成功后
    getPaySuc(data) {
      this.getDetails()
    },
    lazyImage(cover) {
      return {
        src: this.$env.ossUrl(cover),
        error: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png',
        loading: 'https://img.yzcdn.cn/upload_files/2019/12/18/FiHMp7Sh-y_HisCBRFnxeHg-eQWD.png'
      }
    },
    giveFriend() {
      this.show = true
    },
    /** 查询订单详细 id 【订单的编号】 */
    getDetails() {
      this.$http
        .post(
          '/cms/weixin/user/book/order/findAllById',
          getformData({
            id: this.$route.query.payOrderId
          })
        )
        .then((res) => {
          if (res.data && res.data.payOrder) {
            this.details = res.data.payOrder
            this.faqiOpneid = res.data.payAnotherRecord
              ? res.data.payAnotherRecord.creatorOpenid
              : this.details.ntOpenid
            this.payOpenid = this.details.ntOpenid
            this.payOrderId = res.data.payOrder.id
            this.info = res.data
            this.workbooks = res.data.payOrder.payOrderGoods[0]
            var createTime = new Date(res.data.payOrder.createtime.replace(/-/g, '/')).getTime()
            this.time = new Date(createTime).valueOf() + 30 * 60 * 1000 - timestamp()
            this.getShareConfig()



          }
        })
    },
    // 分享支付成功
    getShareConfig() {
      var apps = ['QQ', 'Weibo', 'QZone', 'Timeline', 'AppMessage']
      var template = {
        title: '我已为你付款，快去学习吧～!',
        desc: '付款成功',
        link: `https://${window.location.host}/cms/webapp/home/answer?hash=daifuDetails&id=${this.$route.query.id}&payOrderId=${this.payOrderId}`,
        imgUrl: `https://${window.location.host}/cms/static/images/logo-128.png`,
        success: () => {
          // this.show = false
        },
        cancel: function() {}
      }
      // liaoning.leziedu
      template.link =
        'https://edu.leziedu.com/cms/webapp/home/redirect.html?url=' +
        template.link.replace('?', '&')

      // apps.forEach((item) => window.wx[`onMenuShare${item}`](template))
      this.$wechatJsSdk.then((wx) => {
        // wx.updateAppMessageShareData(template)
        // wx.updateTimelineShareData(template)
        apps.forEach((item) => wx[`onMenuShare${item}`](template))
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.daiFu-overlay {
  img {
    width: 288px;
    margin-left: 63px;
    margin-top: 19px;
  }
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #000000;
}
.vanCount-block {
  display: inline-block;
  width: 20px;
  height: 18px;
  line-height: 18px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: #3e4159;
  border-radius: 2px;
}
.daifuDetails {
  height: auto;
  min-height: 100vh;
  padding-bottom: 20px;
  .neverTop {
    display: flex;
    align-items: center;
    background: #fff;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    height: 40px;
    padding-left: 21px;
    img {
      width: 10px;
      margin-right: 12px;
    }
  }
  .daifuDetails-header_center {
    width: 343px;
    margin: 0 auto;
    padding-bottom: 15px;
    background: #ffffff;
    border-radius: 4px;
    padding-top: 12px;
    padding-left: 14px;
    padding-right: 14px;
    box-sizing: border-box;
    .daifuDetails_dingdan {
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      margin-bottom: 12px;
      font-weight: 500;
    }
    .daifuDetails_flexbox {
      display: flex;
      .dingdan-img {
        width: 53px;
        height: 75px;
        border-radius: 4px;
      }
      .daifuDetails_dingdan-title {
        line-height: 21px;
        font-size: 14px;
        color: #333333;
        margin-bottom: 24px;
      }
      .daifuDetails_flexbox_money {
        font-size: 16px;
        color: #999999;
      }
    }
    .daifuDetails_dingdan_border {
      width: 307px;
      height: 0.5px; /*no*/
      background: #f5f5f5;
      margin-top: 17.5px;
    }
    .daifuDetails_dingdan-text {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      margin-top: 12px;
    }
    .remark {
      margin-top: 8px;
      font-size: 13px;
      color: #666666;
      line-height: 21px;
    }
  }
  .give-friend {
    height: 42px;
    width: 343px;
    margin: 16px auto;
    background: linear-gradient(0deg, #ff2638, #ff2638),
      linear-gradient(90deg, #fd735d 0.16%, #fe4e45 100.16%);
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 42px;
  }
  .daifuDetails_footer {
    padding: 0 16px;
    margin-top: 12px;
    font-size: 13px;
    color: #999999;
    .shuoming {
      font-weight: 500;
      font-size: 14px;
    }
    .daifuDetails_footer_text1 {
      margin-top: 6px;
      font-size: 12px;
      color: #999999;
    }
    .daifuDetails_footer_text2 {
      margin-top: 4px;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
